import Image from "next/image"
import Footer from "components/Layout/Footer/Footer"
import CompanyValuesMobile from "./CompanyValuesMobile"

const AboutUsMobile = () => {
    return (
        <>
            <div className="relative flex w-full flex-col items-center justify-center overflow-hidden">
                <div>
                    <Image
                        src="https://cdn.pass-tickets.com/frontend/Desktop - 9 (2).png"
                        width={0}
                        height={0}
                        alt="hero image"
                        layout="responsive"
                        className="h-72 w-full bg-cover bg-center"
                        quality="100"
                    />
                </div>

                <Image
                    src="https://cdn.pass-tickets.com/frontend/Desktop - 13 (1).png"
                    width={0}
                    height={0}
                    alt="hero image"
                    layout="responsive"
                    className="h-72 w-full bg-cover bg-center"
                    quality="100"
                />
            </div>

            <CompanyValuesMobile />
            <div className="parallax-slide">
                <Footer />
            </div>
        </>
    )
}
export default AboutUsMobile
